import { render } from "./EditTaskPage.vue?vue&type=template&id=1d2bfc60"
import script from "./EditTaskPage.vue?vue&type=script&lang=js"
export * from "./EditTaskPage.vue?vue&type=script&lang=js"

import "./EditTaskPage.vue?vue&type=style&index=0&id=1d2bfc60&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__